// src/data/zencode/zencolor.js


const ZenColor = {
  slug: "zencolor",
  title: "ZenColor",
  description: "Ein achtsames Farbsystem für digitale Entwickler und Medienmenschen.",
  tags: ["Tool", "Design", "Emotion"],
  icon: "palette",
  cover: "/images/projects/zencolor.png",
  content: `


ZenColor ein bewusstes Farbsystem, das Klarheit in kreative Prozesse bringt – für Designer:innen, Entwickler:innen und Menschen, die mit digitalen Farben arbeiten wollen, ohne sich zu verlieren.

Dabei ist uns aufgefallen, dass wir in Entwicklungsphasen oft einen Farbcode-Übersetzer benötigen – idealerweise als JSON-basierte Datenbank.

### Wie funktioniert es?

(Abschnitt folgt noch.)

### Warum es entstanden ist

In der Arbeit mit Medien fiel auf, dass Farben oft nur intuitiv gewählt werden oder bestehende Systeme nicht gut in Fullstack-Prozesse integriert sind.

## ZenColor schafft einen bewussten Rahmen.

# Wir haben uns überlegt: Wie sinnvoll wäre eine direkte Schnittstelle zwischen Design-UI und Code?

Als Fullstack-Entwickler hatte ich den Wunsch, ein eigenes System zu haben, das integriert ist:

- Erlaubt, Farbwerte direkt als JSON in die Entwicklung zu übernehmen  
- Automatisch synchron bei Änderungen im UI  
- Still, funktional, verbindend – auch für andere Schnittstellen

👉 [Du darfst es gerne verwenden](/zencode/zencolor)
`,
};


export default ZenColor;
